import React from "react";
import { CheckBoxInput } from "../../common/Buttons";
import InputForm from "../../common/InputForm";
import ModalToChange from "../../Layout/ModalToChange";

class SmsEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      id: 0,
      name: "",
      address: "",
      rivile_code: "",
      bigbox_import: false,
      action: "new",
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.action === "new" && this.state.action === "edit") {
      this.setState({
        name: "",
        address: "",
        rivile_code: "",
        bigbox_import: false,
        action: "new"
      });
      this.removeErrors(nextProps.errors);
    } else if (nextProps.action === "edit" && nextProps.objectData.id !== this.state.id) {
      let item = nextProps.objectData;
      this.setState({
        id: item.id || 0,
        name: item.name || "",
        address: item.address || "",
        rivile_code: item.rivile_code || "",
        bigbox_import: item.bigbox_import || false,
        action: "edit"
      });
      this.removeErrors(nextProps.errors);
    }
  }

  removeErrors = (errors) => {
    if (Object.keys(errors).length > 0) {
      this.props.clearErrors();
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const variables = {
      store: {
        name: this.state.name,
        address: this.state.address,
        rivile_code: this.state.rivile_code,
        bigbox_import: this.state.bigbox_import,
      },
    };
    if (this.props.action == "new") {
      this.props.postStoreItem(variables);
    } else if (this.props.action === "edit") {
      this.props.updateStoreItem(this.state.id, variables);
    }
  };

  render() {
    return (
      <ModalToChange
        handleSave={(e) => this.onSubmit(e)}
        status="tableEdit"
        text={this.props.action === "new" ? "Create new" : "Edit"}
        buttonText={this.props.action === "new" ? "Create" : "Update"}
      >
        <InputForm
          type="text"
          placeholder="Title"
          name="name"
          value={this.state.name}
          error={
            this.props.errors.name &&
            this.props.errors.name.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Address"
          name="address"
          value={this.state.address}
          error={
            this.props.errors.address &&
            this.props.errors.address.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Rivile code"
          name="rivile_code"
          value={this.state.rivile_code}
          error={
            this.props.errors.rivile_code &&
            this.props.errors.rivile_code.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
         <CheckBoxInput
          choised="bigbox_import"
          color="#f7951e"
          text="Bigbox Import"
          checked={this.state.bigbox_import}
          onChange={(e) =>
            this.handleChange({
              target: { name: "bigbox_import", value: e.target.checked },
            })
          }
        />
      </ModalToChange>
    );
  }
}

export default SmsEditModal;
